const imgSrc = {
	error: 'public/images/report/no-image.png',
	example: (id: string | number) => `https://source.unsplash.com/random?${id}`,
};

const title = {
	loading: '데이터를 불러오는 중',
	empty: '-',
	example: 'example title',
};

const hashtags = {
	empty: new Array(5).fill('-'),
	example: new Array(5).fill('example'),
};

const fallbacks = {
	imgSrc,
	title,
	hashtags,
};

export default fallbacks;
